import {PRODUCT_STOCK_STATUS} from 'constants/product';

/**
 * Get the number of products in stock
 * @param {ProductType} product - Product data.
 * @returns {string} stock status
 */
export const getStockStatus = ({stock}) => {
    if (!stock) return 'N/A';

    let stockStatus = 'In Stock';

    if (
        stock.is_out_of_stock ||
        stock.isOutOfStock ||
        stock.status === PRODUCT_STOCK_STATUS.OUT_OF_STOCK
    )
        stockStatus = 'OOS';

    if (stock.is_low_stock || stock.isLowStock || stock.status === PRODUCT_STOCK_STATUS.LOW_STOCK)
        stockStatus = 'Low In Stock';

    return stockStatus;
};
